class Storage {
    constructor() {
        this.key = 'storage';
    }
    delete() {
        localStorage.removeItem(this.key);
    }
}
export class DesignerStorage extends Storage {
    constructor() {
        super(...arguments);
        this.key = 'frame-designer-options';
    }
    save(item) {
        localStorage.setItem(this.key, JSON.stringify(item));
    }
    load() {
        const item = localStorage.getItem(this.key);
        if (item) {
            return JSON.parse(item);
        }
        return null;
    }
}
export class ImageStorage extends Storage {
    constructor() {
        super(...arguments);
        this.key = 'frame-designer-uploaded-file';
    }
    save(filename) {
        localStorage.setItem(this.key, filename);
    }
    load() {
        return localStorage.getItem(this.key);
    }
}
